import styles from './LoadingSpinner.module.css';

export default function LoadingSpinner() {

    const handleReturn = () => {
        if (window.location.pathname === '/upgrade') {
            return (
                <div className={styles.spinnerUpgrade}>
                    <i className='fa-duotone fa-spinner fa-spin' />
                </div>
            );
        } else {
            return (
                <div className={styles.container}>
                    <i className='fa-duotone fa-spinner fa-spin' />
                </div>
            );
        };
    };

    return (
        <div className={styles.wrapper}>
            {handleReturn()}
        </div>
    );
};